module.exports = __webpack_public_path__ + "img/collection-memoireRingsRedgold.f1f3ad4.jpg";